import { render, staticRenderFns } from "./goodsitem.vue?vue&type=template&id=d7c71edc&scoped=true"
import script from "./goodsitem.vue?vue&type=script&lang=js"
export * from "./goodsitem.vue?vue&type=script&lang=js"
import style0 from "./goodsitem.vue?vue&type=style&index=0&id=d7c71edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c71edc",
  null
  
)

export default component.exports